<template>
    <MembershipComp></MembershipComp>
  </template>
  <script>
  import MembershipComp from "../components/MembershipReport.vue";
  
  export default {
    name: "Commission Report",
    components: { MembershipComp },
    computed: {},
    mounted() {},
  };
  </script>
  